import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TitleSubtitle from "../../components/common/TitleSubtitle";
import NewNotifications from "./NewNotification";
import ActiveNotifications from "./ActiveNotification";
import styles from "./NotifySurface.module.css";

const Notification: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const [activeTab, setActiveTab] = useState<"newNotification" | "activeNotifications">("newNotification");

    const handleTabClick = (tab: "newNotification" | "activeNotifications") => {
        setActiveTab(tab);
    };

    return (
        <div className={styles.root}>
            <div className={styles.page}>
                <div className={styles.pageTitle}>
                    <TitleSubtitle title={t("notification")} subtitle={t("notificationSub")} />
                </div>

                <div className={styles.stepDescription}>
                    <div className={styles.tabs}>
                        <div
                            className={`${styles.tab} ${activeTab === "newNotification" ? styles.tabActive : ""}`}
                            onClick={() => handleTabClick("newNotification")}
                        >
                            {t("newNotification")}
                        </div>
                        <div
                            className={`${styles.tab} ${activeTab === "activeNotifications" ? styles.tabActive : ""}`}
                            onClick={() => handleTabClick("activeNotifications")}
                        >
                            {t("activeNotifications")}
                        </div>
                    </div>

                    {activeTab === "newNotification" && (
                        <div>
                            <NewNotifications setActiveTab={setActiveTab} />
                        </div>
                    )}

                    {activeTab === "activeNotifications" && (
                        <div>
                            <ActiveNotifications />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Notification;
